import React from "react";
import ContactForm from "./ContactForm";
import "./ContactFull.css";

function ContactFull() {
  return (
    <div className="contact-main-box">
      <div className="contact-top-box"></div>
      <ContactForm></ContactForm>
    </div>
  );
}

export default ContactFull;
